import RedesignBaseDataLoadChart from '@/components/RedesignComponents/Charts/RedesignBaseDataLoadChart.vue'
import RedesignBarLineChart from '@/components/RedesignComponents/Charts/RedesignBarLineChart.vue'
import RedesignPieChart from '@/components/RedesignComponents/Charts/RedesignPieChart.vue'
import RedesignTimeLineChart from '@/components/RedesignComponents/Charts/RedesignTimeLineChart.vue'
import RedesignQueueChart from '@/components/RedesignComponents/Charts/RedesignQueueChart.vue'
import RedesignAreaChart from '@/components/RedesignComponents/Charts/RedesignAreaChart.vue'
import RedesignXaxisChart from '@/components/RedesignComponents/Charts/RedesignXaxisChart.vue'
import RedesignFunnel3DChart from '@/components/RedesignComponents/Charts/RedesignFunnel3DChart.vue'

export default {
    RedesignBaseDataLoadChart,
    RedesignBarLineChart,
    RedesignPieChart,
    RedesignTimeLineChart,
    RedesignQueueChart,
    RedesignAreaChart,
    RedesignXaxisChart,
    RedesignFunnel3DChart
}
